import { Box, Stack, Typography, styled } from "@mui/material";

const LogoDescription = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    fontSize: "25px",
    [theme.breakpoints.down("md")]: {
        fontSize: "20px",
    },
}));

export default function Logo() {
    return (
        <Stack direction="column" alignItems="center" gap="20px">
            <Box sx={{ width: { xs: "94px", md: "150px" } }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    viewBox="0 0 150 150"
                    fill="none"
                >
                    <path
                        d="M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z"
                        fill="#0E4571"
                    />
                    <path
                        d="M69.041 22.6589V51.8019L73.5813 47.9001V22.6589H69.041Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M46.3818 74.8014V81.9665L52.5822 76.6317L54.0436 75.3689L73.581 58.5414V51.3621V51.3763L52.5822 69.4523L46.3818 74.7872V74.8014Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M46.3818 85.4285V109.974L52.5822 115.409L66.2031 127.341V86.8899L54.6253 96.8643L52.5822 98.6237V80.1078L46.3818 85.4285Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M31.7964 54.4126V73.042L66.2033 43.4024V22.6589L31.7964 54.4126Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M66.2033 46.8786L31.7964 76.504V97.1907L43.5302 107.477V73.7798L66.2033 54.2565V46.8786Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M108.91 45.8428V45.857L98.4678 36.2089L108.91 45.8428Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M94.0409 32.1084V118.374L83.8111 127.341H76.4331V22.6589H83.8111V22.6731L94.0409 32.1084Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M98.4677 36.2089L108.91 45.857V105.349L96.8076 115.962V34.6765L98.4677 36.2089Z"
                        fill="#E9E9E9"
                    />
                    <path
                        d="M118.204 54.4126V97.1907L111.677 102.909V48.3967L118.204 54.4126Z"
                        fill="#E9E9E9"
                    />
                </svg>
            </Box>
            <LogoDescription>پرشین سازه</LogoDescription>
        </Stack>
    );
}
